// extracted by mini-css-extract-plugin
export default {"cellAnswerTextColumn":"SQGZD6PvJayKZoDNIfVV"};